var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCorporat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party_9lnxbk2whhfb 2",
    clipPath: "url(#clip0_11_457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.3233 19.3335C45.9881 18.5909 45.1143 18.2606 44.3716 18.5958C44.3622 18.6001 44.3528 18.6045 44.3435 18.6089C30.905 24.8215 16.2804 28.0493 1.47541 28.0707C0.660613 28.0707 0 28.7313 0 29.5461C0 30.3609 0.660613 31.0215 1.47541 31.0215C2.86229 31.0215 4.25065 30.9625 5.63753 30.9064L13.5737 41.4881C13.8524 41.8595 14.2897 42.0782 14.7541 42.0782C14.8098 42.0782 14.8655 42.0753 14.9208 42.0694C15.4401 42.0098 15.8892 41.6797 16.1011 41.2018L21.51 29.0327C23.2804 28.6874 25.0382 28.2974 26.7831 27.8627L37.4753 35.8815C38.128 36.3695 39.0525 36.236 39.5405 35.5835C39.6936 35.3788 39.7908 35.1377 39.8227 34.8841L41.2981 23.1325C42.7396 22.5424 44.1752 21.9404 45.5856 21.2853C46.3283 20.95 46.6586 20.0762 46.3233 19.3335ZM14.428 37.7066L9.16965 30.6969C12.1205 30.4771 15.0713 30.154 17.9926 29.6848L14.428 37.7066ZM37.2127 31.9953L30.4258 26.9066C33.0417 26.1556 35.6207 25.2837 38.1673 24.3394L37.2127 31.9953Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.353 55.7877L42.3533 55.788L42.355 55.7897L42.353 55.7877Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.3533 55.7879L33.5022 46.9367C32.926 46.3608 31.9921 46.3608 31.416 46.9367L18.4929 59.8584C15.8753 62.4765 15.4819 66.5831 17.5545 69.6506L9.71715 77.488H1.47553C0.660733 77.4882 0.000303894 78.1488 0.00048832 78.9638C0.00048832 79.3549 0.155959 79.7299 0.432414 80.0065L9.28485 88.859C9.86119 89.4351 10.7953 89.4349 11.3714 88.8586C11.6479 88.582 11.8034 88.2068 11.8034 87.8158V79.5742L19.6407 71.7339C22.7087 73.8076 26.8164 73.4127 29.433 70.7926L34.9761 65.251L42.3531 57.8739C42.9291 57.2978 42.9291 56.364 42.3533 55.7879ZM8.85256 84.2542L5.03716 80.4388H8.85256V84.2542ZM27.3453 68.7108C25.4869 70.5744 22.4695 70.5789 20.6058 68.7204C19.7921 67.9091 19.299 66.8309 19.2173 65.6847H30.3714L27.3453 68.7108ZM33.3237 62.7339H19.9491C20.132 62.4494 20.3436 62.1845 20.5806 61.9431L32.4591 50.0661L39.2253 56.8323L33.3237 62.7339Z",
    fill: "#222222"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M89.8877 78.3983C89.6592 77.8471 89.1211 77.4878 88.5245 77.488H80.2828L72.4425 69.6506C74.5157 66.5823 74.1214 62.475 71.5027 59.8569L58.5811 46.9367C58.0049 46.3608 57.071 46.3608 56.4949 46.9367L47.6424 55.7892C47.0665 56.3653 47.0665 57.2993 47.6424 57.8754L53.544 63.777L60.5611 70.7941C63.1783 73.4144 67.2865 73.8093 70.3548 71.7354L78.1966 79.5742V87.8158C78.1968 88.6306 78.8574 89.2911 79.6724 89.2909C80.0636 89.2909 80.4385 89.1354 80.7151 88.859L89.5676 80.0065C89.9897 79.5846 90.1162 78.9498 89.8877 78.3983ZM50.7747 56.8323L57.5409 50.0661L68.7334 61.2585H55.2009L50.7747 56.8323ZM67.1574 69.9769C65.5367 70.3703 63.8282 69.8898 62.6503 68.7091H62.6532L58.1532 64.2092H70.672C71.2943 66.7725 69.7206 69.3548 67.1574 69.9769ZM81.1474 84.2542V80.4388H84.9628L81.1474 84.2542Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M87.0491 14.0455H68.3778C52.2908 14.0508 36.5301 9.50567 22.9161 0.935033C22.226 0.501448 21.3151 0.709664 20.8816 1.39979C20.448 2.08991 20.6562 3.00079 21.3463 3.43437C23.524 4.80355 25.7592 6.06207 28.0328 7.23059V19.9471C28.0328 20.7619 28.6935 21.4225 29.5083 21.4225C29.8275 21.4225 30.1381 21.3191 30.3935 21.1274L41.4945 12.8017C43.923 13.5778 46.3819 14.2467 48.8715 14.8083L53.2062 26.3666C53.3892 26.8553 53.8167 27.2109 54.3305 27.302C54.4163 27.3168 54.5031 27.3242 54.5902 27.3242C55.0206 27.3242 55.4297 27.136 55.71 26.8092L64.2157 16.8871C65.5997 16.952 66.9865 16.9963 68.3778 16.9963H68.5254L75.4701 28.1061C75.8993 28.7988 76.8089 29.0122 77.5014 28.583C77.695 28.463 77.8583 28.2998 77.9783 28.1061L84.9157 16.9963H87.0491C87.8639 16.9963 88.5245 16.3357 88.5245 15.5209C88.5245 14.7061 87.8639 14.0455 87.0491 14.0455ZM30.9837 16.9963V8.67797C33.3207 9.76977 35.6946 10.7701 38.1114 11.6509L30.9837 16.9963ZM55.0948 22.9924L52.29 15.5209C55.0166 16.0255 57.7682 16.3997 60.5449 16.6437L55.0948 22.9924ZM76.7213 24.5401L72 16.9963H81.4426L76.7213 24.5401Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.262 37.9471C43.4472 37.9471 42.7866 38.6077 42.7866 39.4225V43.8487C42.7866 44.6635 43.4472 45.3241 44.262 45.3241C45.0768 45.3241 45.7374 44.6635 45.7374 43.8487V39.4225C45.7374 38.6077 45.0768 37.9471 44.262 37.9471Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M41.1139 44.2943L38.9008 40.4582C38.4934 39.7526 37.591 39.5108 36.8854 39.9182C36.1797 40.3256 35.938 41.228 36.3454 41.9336L38.5585 45.7697C38.9705 46.4727 39.8745 46.7084 40.5774 46.2964C41.2738 45.8881 41.5128 44.996 41.1139 44.2943Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M40.5739 64.407C39.8683 63.9996 38.9659 64.2414 38.5585 64.947L36.3454 68.7831C35.9334 69.4861 36.1691 70.39 36.8721 70.802C37.5751 71.214 38.479 70.9783 38.891 70.2753C38.8943 70.2697 38.8974 70.264 38.9008 70.2583L41.1139 66.4223C41.5213 65.7168 41.2795 64.8144 40.5739 64.407Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M44.262 65.3897C43.4472 65.3897 42.7866 66.0503 42.7866 66.8651V71.2913C42.7866 72.1061 43.4472 72.7667 44.262 72.7667C45.0768 72.7667 45.7374 72.1061 45.7374 71.2913V66.8651C45.7374 66.0503 45.0768 65.3897 44.262 65.3897Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M52.178 68.7831L49.9648 64.947C49.5622 64.2387 48.6615 63.9908 47.9531 64.3934C47.2447 64.796 46.9969 65.6967 47.3995 66.4051C47.4028 66.4108 47.4061 66.4165 47.4094 66.4223L49.6226 70.2583C49.8863 70.7153 50.3741 70.9966 50.9017 70.996C51.7165 70.9951 52.3764 70.3339 52.3757 69.5191C52.3753 69.2608 52.3072 69.007 52.178 68.7831Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M51.6531 39.9116C50.9503 39.4994 50.0462 39.7351 49.634 40.438C49.6307 40.4437 49.6274 40.4494 49.624 40.4551L47.4109 44.2912C46.9987 44.994 47.2344 45.8981 47.9373 46.3103C48.6401 46.7224 49.5442 46.4868 49.9564 45.7839C49.9597 45.7782 49.963 45.7725 49.9663 45.7668L52.1794 41.9307C52.5916 41.2278 52.3559 40.3238 51.6531 39.9116Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M63.4423 77.488C60.9978 77.488 59.0161 79.4696 59.0161 81.9142C59.0161 84.3588 60.9978 86.3404 63.4423 86.3404C65.8869 86.3404 67.8686 84.3588 67.8686 81.9142C67.8686 79.4696 65.8869 77.488 63.4423 77.488ZM63.4423 83.3896C62.6275 83.3896 61.9669 82.729 61.9669 81.9142C61.9669 81.0994 62.6275 80.4388 63.4423 80.4388C64.2571 80.4388 64.9177 81.0994 64.9177 81.9142C64.9177 82.729 64.2571 83.3896 63.4423 83.3896Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M14.7539 45.0291C12.3093 45.0291 10.3276 47.0107 10.3276 49.4553C10.3276 51.8998 12.3093 53.8815 14.7539 53.8815C17.1984 53.8815 19.1801 51.8998 19.1801 49.4553C19.1801 47.0107 17.1984 45.0291 14.7539 45.0291ZM14.7539 50.9307C13.9391 50.9307 13.2785 50.2701 13.2785 49.4553C13.2785 48.6405 13.9391 47.9799 14.7539 47.9799C15.5687 47.9799 16.2293 48.6405 16.2293 49.4553C16.2293 50.2701 15.5687 50.9307 14.7539 50.9307Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M67.8386 34.2372C67.7156 33.4644 67.2907 32.7721 66.6572 32.3125H66.6513C65.3321 31.3557 63.4869 31.6495 62.5301 32.9687C61.5733 34.2879 61.8671 36.1331 63.1863 37.0899C63.6898 37.455 64.2958 37.6518 64.9177 37.652C65.0754 37.6522 65.2327 37.6398 65.3883 37.6151C66.9978 37.359 68.0948 35.8465 67.8386 34.2372Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M32.4591 81.9142C34.0888 81.9142 35.4099 80.5931 35.4099 78.9634C35.4099 77.3337 34.0888 76.0126 32.4591 76.0126C30.8294 76.0126 29.5083 77.3337 29.5083 78.9634C29.5083 80.5931 30.8294 81.9142 32.4591 81.9142Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M78.1966 47.9799C77.3818 47.9799 76.7212 48.6405 76.7212 49.4553V50.9307C76.7212 51.7455 77.3818 52.4061 78.1966 52.4061C79.0114 52.4061 79.672 51.7455 79.672 50.9307V49.4553C79.672 48.6405 79.0114 47.9799 78.1966 47.9799Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M78.1966 40.6028C77.3818 40.6028 76.7212 41.2634 76.7212 42.0782V43.5536C76.7212 44.3684 77.3818 45.029 78.1966 45.029C79.0114 45.029 79.672 44.3684 79.672 43.5536V42.0782C79.672 41.2634 79.0114 40.6028 78.1966 40.6028Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M82.6227 45.0291H81.1473C80.3325 45.0291 79.6719 45.6897 79.6719 46.5045C79.6719 47.3193 80.3325 47.9799 81.1473 47.9799H82.6227C83.4375 47.9799 84.0981 47.3193 84.0981 46.5045C84.0981 45.6897 83.4375 45.0291 82.6227 45.0291Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M75.2457 45.0291H73.7703C72.9555 45.0291 72.2949 45.6897 72.2949 46.5045C72.2949 47.3193 72.9555 47.9799 73.7703 47.9799H75.2457C76.0605 47.9799 76.7211 47.3193 76.7211 46.5045C76.7211 45.6897 76.0605 45.0291 75.2457 45.0291Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M48.6883 84.865C47.8735 84.865 47.2129 85.5256 47.2129 86.3404V87.8158C47.2129 88.6306 47.8735 89.2913 48.6883 89.2913C49.5031 89.2913 50.1637 88.6306 50.1637 87.8158V86.3404C50.1637 85.5256 49.5031 84.865 48.6883 84.865Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M48.6883 77.488C47.8735 77.488 47.2129 78.1486 47.2129 78.9634V80.4388C47.2129 81.2536 47.8735 81.9142 48.6883 81.9142C49.5031 81.9142 50.1637 81.2536 50.1637 80.4388V78.9634C50.1637 78.1486 49.5031 77.488 48.6883 77.488Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M53.1149 81.9142H51.6395C50.8247 81.9142 50.1641 82.5748 50.1641 83.3896C50.1641 84.2044 50.8247 84.865 51.6395 84.865H53.1149C53.9297 84.865 54.5903 84.2044 54.5903 83.3896C54.5903 82.5748 53.9297 81.9142 53.1149 81.9142Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M45.7374 81.9142H44.262C43.4472 81.9142 42.7866 82.5748 42.7866 83.3896C42.7866 84.2044 43.4472 84.865 44.262 84.865H45.7374C46.5522 84.865 47.2128 84.2044 47.2128 83.3896C47.2128 82.5748 46.5522 81.9142 45.7374 81.9142Z",
    fill: "#222222"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorporat);
export default __webpack_public_path__ + "static/media/icon-corporat.dac621df7dcc8e9b222d9ea9f382b550.svg";
export { ForwardRef as ReactComponent };